import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import {bounceMessage} from '../userMessages/UserMessage';
import Share from '../../assets/icons/share';

interface ShareButtonProps {
    url: string;
    title: string;
    className?: string;
}

function ShareButton({url, title, className}: ShareButtonProps) {
    const {t} = useTranslation('layout');

    const copyToClipboard = async () => {
        await navigator.clipboard.writeText(url);
        bounceMessage(t('linkCopied'), 'success');
    };

    const handleShare = async () => {
        try {
            if (navigator.share) {
                await navigator.share({
                    title,
                    url
                });
            } else {
                await copyToClipboard();
            }
        } catch (error) {
            if ((error as Error).name !== 'AbortError') {
                await copyToClipboard();
            }
        }
    };

    return (
        <Button
            iconStart={<Share />}
            onClick={handleShare}
            className={className}
            title={t('shareVideo')}
            size="category"
        />
    );
}

export default ShareButton;

